module.exports = __webpack_public_path__ + "static/media/logo-login.7742aff4.png";